import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfigService, StoreService } from 'app/services';
import { OperationHour, SpecialHour } from 'app/models';
import { PartnerMartLocationsHoursComponent } from 'app/partner';
import { Utils } from 'app/utils';

@Component({
    selector: 'partner-mart-locations-group-hours',
    templateUrl: './partner-mart-locations-group-hours.component.html',
    styleUrls: [
        './partner-mart-locations-group-hours.component.scss',
        '../../partner-mart-locations-root/partner-mart-locations-root.component.scss'
    ],
    providers: [MessageService]
})
export class PartnerMartLocationsGroupHoursComponent implements OnInit {
    @Input()
    public groupId: number = 0;

    @Input()
    public groupName: string = '';

    @ViewChild(PartnerMartLocationsHoursComponent, { static: true })
    private partnerMartLocationsHours?: PartnerMartLocationsHoursComponent;

    public groupHours: any = {};

    public operationHours: OperationHour[] = [new OperationHour()];
    public specialHours: SpecialHour[] = [new SpecialHour()];

    constructor(
        private messageService: MessageService,
        public configService: ConfigService,
        private storeService: StoreService) {
    }

    ngOnInit(): void {
        this.getGroupHours();
    }

    private getGroupHours(): void {
        const dto = {
            GroupId: this.groupId
        };

        this.storeService.getStoreGroupHours(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.groupHours = data;

                this.parseGroupHours();
            });
    }

    private parseGroupHours(): void {
        // OperationHours
        this.operationHours = [];

        if (!this.groupHours.OperationHourItems || !this.groupHours.OperationHourItems.length) {
            this.operationHours.push(new OperationHour());
        }
        else {
            this.groupHours.OperationHourItems.forEach((obj: any) => {
                this.operationHours.push({
                    SelectedDaysWeek: obj.DayOfWeeks,
                    SelectStartTime: new Date(obj.StartTime), SelectStartTimeIsEmpty: false,
                    SelectEndTime: new Date(obj.EndTime), SelectEndTimeIsEmpty: false,
                });
            });
        }

        // SpecialHours
        this.specialHours = [];

        if (!this.groupHours.GroupSpecialHours || !this.groupHours.GroupSpecialHours.length) {
            this.specialHours.push(new SpecialHour());
        }
        else {
            this.groupHours.GroupSpecialHours.forEach((obj: any) => {
                const specialHour: SpecialHour = {
                    Title: obj.Title,
                    StartDate: new Date(obj.StartDate),
                    EndDate: new Date(obj.EndDate),
                    IsOpen: obj.IsOpen,
                    StoreSpecialHourTimes: []
                };

                if (!obj.StoreSpecialHourTimes || !obj.StoreSpecialHourTimes.length) {
                    specialHour.StoreSpecialHourTimes.push({
                        OpensAt: null,
                        ClosesAt: null
                    });
                }
                else {
                    obj.StoreSpecialHourTimes.forEach((time: any) => {
                        specialHour.StoreSpecialHourTimes.push({
                            OpensAt: new Date(time.OpensAt),
                            ClosesAt: new Date(time.ClosesAt)
                        });
                    });
                }

                this.specialHours.push(specialHour);
            });
        }
    }

    public onSaveHoursClick(): void {
        if (!this.partnerMartLocationsHours) {
            console.error('partnerMartLocationsHours not found');
            return;
        }

        this.operationHours = this.partnerMartLocationsHours.getOperationHours();
        this.specialHours = this.partnerMartLocationsHours.getSpecialHours();

        const dto = {
            GroupId: this.groupId,
            GroupOperationHours: this.partnerMartLocationsHours.getOperationHoursDto(),
            GroupSpecialHours: this.partnerMartLocationsHours.getSpecialHoursDto(),
            TimeZoneOffSet: Utils.getTimezoneOffset()
        };

        this.storeService.updateStoreGroupHours(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully saved' });
            });
    }
}
